export * from './services'
export * from './ui-helper'
export * from './components'
import {MerchantUiComponent,EventListComponent } from './components'
import * as services from './services'
import {Http} from '@angular/http';
import { ACTION_PROVIDER } from './actions';
import effects from './effects';
import reducer from './reducers';
import webservices from './services/webservice'
import './array'

export{
	EventListComponent
}
export const APP_PROVIDERS = [
	...services.SERVICE_PROVIDER,
	...ACTION_PROVIDER,

]


// WEBPACK FOOTER //
// ./src/app/index.ts